import { createFileRoute } from '@tanstack/react-router'

// /orgs/$orgId/groups/$groupId — group selected, no report open. This is the URL of the NAV STACK's middle
// level: the group's users list, with the report one push further in (see nav-stack.tsx, and the depth
// derivation in orgs.tsx). Making it a real route rather than a search-param flag is what lets the browser
// Back button pop the stack, keeps the level deep-linkable, and distinguishes "opened the group" from "asked
// for the group's own report" — two states that were the same URL before.
//
// It renders nothing into the report Outlet: on mobile that pane is off-stage, and on desktop it is the empty
// detail pane (the same shape `/offers/$offerId` has always had). The `groups.$groupId` layout above provides
// the params and owns the chrome prefetch (getGroups + getOrgGroupUsers), so this leaf needs no loader.
export const Route = createFileRoute('/_app/orgs/$orgId/groups/$groupId/')({
  component: () => null,
})
